/*
 *  Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../../../../components/Container/Container";
import Typography from "@mui/material/Typography";
import {Box, Stack} from "@mui/material";
import WbsLegalbirdOverlapped from "../../../../../../assets/img/landingpage/wbs/wbs_legalbird_overlapped.svg";
import WbsLogo from "../../../../../../assets/img/landingpage/wbs/wbs_1.svg";
import LegalbirdLogo from "../../../../../../assets/img/landingpage/wbs/Legalbird_Bird.svg";
import Grid from "@mui/material/Grid";
import ColoredLogoBox from "./ColoredLogoBox";

export default function LegalbirdWbsPartnerSection() {
  return (
    <Container>
      <Typography variant={"h2"} textAlign={"center"}>
        Zwei Experten für dein Recht
      </Typography>
      <Typography variant={"subtitle2"} textAlign={"center"} marginY={4}>
        Deine Daten wurden widerrechtlich an die SCHUFA / CRIF weitergegeben? Zwei Experten der Rechtsbranche setzen sich persönlich für dein Recht auf
        Schadensersatz ein!
      </Typography>
      <Stack direction="row" spacing={2} justifyContent={"center"} margin={4}>
        <Box component={"img"} sx={{ maxWidth: "70vw" }} src={WbsLegalbirdOverlapped} alt={"WBS & Legalbird"} />
      </Stack>
      <Grid container direction={"row"} marginTop={2} spacing={3}>
        <Grid item xs={12} md={6}>
          <ColoredLogoBox
            color={"#FFE0DB"}
            logo={WbsLogo}
            title={"WBS.LEGAL"}
            description={"Die Rechts-Experten für Medien, E-Commerce und Internet mit 30 Jahren Erfahrung."}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ marginTop: { xs: "2rem", md: 0 } }}>
          <ColoredLogoBox
            color={"#D9EBEA"}
            logo={LegalbirdLogo}
            title={"Legalbird"}
            description={"Professionelle Abwicklung deines Falls mit modernster Technologie, damit du das beste Ergebnis erhältst."}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
